import React, { useEffect } from "react";
import Sidebar from "./sidebar";
import TopNav from "./top-nav";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { useProfile } from "../../../Utils/ProfileContext";
import { useMediaQuery, useTheme } from "@mui/material";

const SellerSharedLayout = () => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const { refetchProfile } = useProfile();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (!isAuthenticated || typeof refetchProfile !== "function") return;
    (async () => {
      try {
        await refetchProfile();
      } catch (e) {
        // Silent: stale profile is acceptable here.
      }
    })();
  }, [isAuthenticated, refetchProfile]);

  return (
    <div className="flex h-[100dvh] bg-[#F8F8F8] overflow-hidden">
      {isMobile ? null : <Sidebar />}
      <div className="flex flex-col flex-1 min-w-0 h-full">
        <TopNav />
        <main className="flex-1 overflow-y-auto px-4 sm:px-6 mt-14">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SellerSharedLayout;